import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { ApiService } from "src/app/api.service";
import { DvsUtilities } from "src/app/dvs-utilities";
import { ActionButtonComponent } from "src/app/shared/action-button/action-button.component";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-files-control",
	templateUrl: "./files-control.component.html",
	styleUrls: ["./files-control.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [ActionButtonComponent]
})
export class FilesControlComponent implements OnInit {
	private api = inject(ApiService);
	private route = inject(ActivatedRoute);

	public listing: APIResults.FileListing;
	public isUploading = false;
	public uploadError = undefined;
	public uploadSuccess = undefined;

	async ngOnInit(): Promise<void> {
		await this.RefreshPath();
	}

	private async RefreshPath() {
		this.listing = undefined;
		const assetId = this.route.snapshot.params["assetid"];
		this.listing = await this.api.GetFileListing(assetId, "control", "");
	}

	public async DownloadFile(file: string) {
		const assetId = this.route.snapshot.params["assetid"];
		await this.api.GetFileDownload(assetId, "control", file, file);
	}

	public async DeleteFile(file: string) {
		const assetId = this.route.snapshot.params["assetid"];
		await this.api.DeleteControlFile(assetId, file);
		await this.RefreshPath();
	}

	public async PerformUpload(event: any) {
		this.isUploading = true;
		this.uploadError = undefined;
		this.uploadSuccess = undefined;
		try {
			const files: File[] = Array.from(event.target.files);
			const assetId = this.route.snapshot.params["assetid"];
			for (const file of files) {
				await this.api.UploadControlFile(assetId, file);
			}
			await this.RefreshPath();
			const uploaded = (files.length !== 1) ? files.length + " files" : files[0].name
			this.uploadSuccess = uploaded + " uploaded successfully";
		} catch (err) {
			this.uploadError = DvsUtilities.GetRemoteErrorMessage(err, "Couldn't upload file(s)");
		} finally {
			this.isUploading = false;
		}
	}
}
